import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Validators } from 'ngx-editor';
import { ActionStatus } from 'src/app/enum/ActionStatus';
import { ActivityServiceService } from 'src/app/services/activity-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-manage-action-details',
  templateUrl: './manage-action-details.component.html',
  styleUrls: ['./manage-action-details.component.scss']
})
export class ManageActionDetailsComponent implements OnInit {
  form: FormGroup
  applicationActivityId: any;
  details: any
  action: ActionStatus
  savedisble = false;
  actionvisible = true;
  data: any = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "ActionTakenBy",
    "ActionTakenOn",
    "ActionComments"
  ];
  constructor(
    private activityservice: ActivityServiceService,
    private activateroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: NotificationService,
    private navigationService: NavigationService,

  ) {
    this.activateroute.params.subscribe((params: any) => {
      debugger
      this.applicationActivityId = parseInt(params.id);
    });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      activityNo: [],
      activityType: [],
      personResponsible: [],
      targetDate: [],
      customerName: [],
      comments: [],
      actionComments: [,Validators.required],
      complete: [false]

    })
    this.getdata();
    this.form.disable()
    this.form.get('actionComments').enable()
    this.form.get('complete').enable()

  }
  gotomanageaction() {
this.navigationService.gotomanageaction();
  }
  getdata() {
    let postdata = {
      applicationActivityId: this.applicationActivityId
    }
    this.activityservice.getManageActionList(postdata).subscribe((result) => {
      this.details = result[0];

      this.form.patchValue(this.details);

      console.log(this.form.value)
      if (this.details.status === ActionStatus.Closed) {
        this.savedisble = true;
        this.actionvisible = false;

      }
      this.activityservice.getPreviousActionList(postdata).subscribe((result) => {
        this.data = result;
        this.dataSource = new MatTableDataSource(this.data);


      })
    })
  }

  save() {
    if(!this.form.value.actionComments){
      this.form.get('actionComments')?.setErrors({ 'required': true });
    return;
    }

    this.details.applicationActivity_Id = this.details.applicationActivityId;
    this.details.actionComments = this.form.value.actionComments;

    if (this.form.value.complete)
      this.details.actionStatus = ActionStatus.Closed;
    else
      this.details.actionStatus = ActionStatus.InProgress;
    console.log(this.details)
    this.activityservice.saveActionTaken(this.details).subscribe((result)=>{
      this.toastr.showSuccess("Saved Successfully!")
    this.navigationService.gotomanageaction();

    })


  }


}
